var map = {
	".": [
		11,
		9
	],
	"./": [
		11,
		9
	],
	"./App": [
		14,
		9
	],
	"./App.css": [
		47,
		7
	],
	"./App.js": [
		14,
		9
	],
	"./App.test": [
		54,
		9,
		0,
		1,
		4
	],
	"./App.test.js": [
		54,
		9,
		0,
		1,
		4
	],
	"./Book": [
		15,
		9
	],
	"./Book.css": [
		48,
		7
	],
	"./Book.js": [
		15,
		9
	],
	"./Book.test": [
		55,
		9,
		0,
		1,
		3
	],
	"./Book.test.js": [
		55,
		9,
		0,
		1,
		3
	],
	"./BookAPI": [
		12,
		9
	],
	"./BookAPI.js": [
		12,
		9
	],
	"./BookContent.css": [
		49,
		7
	],
	"./Code": [
		16,
		9
	],
	"./Code.css": [
		50,
		7
	],
	"./Code.js": [
		16,
		9
	],
	"./Code.test": [
		56,
		9,
		0,
		1,
		5
	],
	"./Code.test.js": [
		56,
		9,
		0,
		1,
		5
	],
	"./book/00-welcome": [
		20,
		9
	],
	"./book/00-welcome.js": [
		20,
		9
	],
	"./book/01-html": [
		21,
		9
	],
	"./book/01-html.js": [
		21,
		9
	],
	"./book/02-texts": [
		22,
		9
	],
	"./book/02-texts.js": [
		22,
		9
	],
	"./book/03-links": [
		23,
		9
	],
	"./book/03-links.js": [
		23,
		9
	],
	"./book/04-css": [
		24,
		9
	],
	"./book/04-css.js": [
		24,
		9
	],
	"./book/05-rules": [
		25,
		9
	],
	"./book/05-rules.js": [
		25,
		9
	],
	"./book/06-colors": [
		26,
		9
	],
	"./book/06-colors.js": [
		26,
		9
	],
	"./book/07-fonts": [
		27,
		9
	],
	"./book/07-fonts.js": [
		27,
		9
	],
	"./book/08-align": [
		28,
		9
	],
	"./book/08-align.js": [
		28,
		9
	],
	"./book/09-listas": [
		29,
		9
	],
	"./book/09-listas.js": [
		29,
		9
	],
	"./book/10-table": [
		30,
		9
	],
	"./book/10-table.js": [
		30,
		9
	],
	"./book/11-containers": [
		31,
		9
	],
	"./book/11-containers.js": [
		31,
		9
	],
	"./book/12-dimensions": [
		32,
		9
	],
	"./book/12-dimensions.js": [
		32,
		9
	],
	"./book/13-borders": [
		33,
		9
	],
	"./book/13-borders.js": [
		33,
		9
	],
	"./book/14-outlines": [
		34,
		9
	],
	"./book/14-outlines.js": [
		34,
		9
	],
	"./book/15-spacing": [
		35,
		9
	],
	"./book/15-spacing.js": [
		35,
		9
	],
	"./book/16-display": [
		36,
		9
	],
	"./book/16-display.js": [
		36,
		9
	],
	"./book/17-position": [
		37,
		9
	],
	"./book/17-position.js": [
		37,
		9
	],
	"./book/18-forms": [
		38,
		9
	],
	"./book/18-forms.js": [
		38,
		9
	],
	"./book/19-buttons": [
		39,
		9
	],
	"./book/19-buttons.js": [
		39,
		9
	],
	"./book/99-credits": [
		40,
		9
	],
	"./book/99-credits.js": [
		40,
		9
	],
	"./code/placeholder": [
		9,
		9
	],
	"./code/placeholder.js": [
		9,
		9
	],
	"./index": [
		11,
		9
	],
	"./index.css": [
		46,
		7
	],
	"./index.js": [
		11,
		9
	],
	"./reset.css": [
		45,
		7
	],
	"./serviceWorker": [
		17,
		9
	],
	"./serviceWorker.js": [
		17,
		9
	],
	"./setupTests": [
		57,
		9,
		0,
		2,
		6
	],
	"./setupTests.js": [
		57,
		9,
		0,
		2,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 63;
module.exports = webpackAsyncContext;